import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SearchIcon from "../Assests/activeSearch.svg"
import "./Components.css"

const Searchbar = ({ 
  searchTerm, 
  setSearchTerm, 
  handleKeyDown, 
  placeholder, 
  handleSearhItem,
  alwaysShowIcon = false,
  customStyles = {},
  inputStyles = {},
  iconStyles = {},
  onSearch,
  onSearchTermChange
}) => {
    const [isActive, setIsActive] = useState(false);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (setSearchTerm) setSearchTerm(value);
        if (onSearchTermChange) onSearchTermChange(value);
        if (onSearch) onSearch(value);
    };

    return (
        <div className="search_Container">
            <div 
                className={`search-bar ${isActive ? 'active' : ''}`}
                style={customStyles}
            >
                <input
                    type="text"
                    className="search-input"
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                    onFocus={() => setIsActive(true)}
                    onBlur={() => setIsActive(false)}
                    style={inputStyles}
                />
                {
                    (alwaysShowIcon || searchTerm) && (
                        <img 
                            src={SearchIcon} 
                            alt="Search" 
                            className="search-icon" 
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                }
                            }}
                            tabIndex={0}
                            role="button"
                            style={iconStyles}
                        />
                    )
                }
            </div>
        </div>
    )
}

Searchbar.propTypes = {
    searchTerm: PropTypes.string,
    setSearchTerm: PropTypes.func,
    handleKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    handleSearhItem: PropTypes.func,
    alwaysShowIcon: PropTypes.bool,
    customStyles: PropTypes.object,
    inputStyles: PropTypes.object,
    iconStyles: PropTypes.object,
    onSearch: PropTypes.func,
    onSearchTermChange: PropTypes.func
};

export default Searchbar
